/**
 * Coups de pouce — Attendu 613 « Calculer le produit de deux nombres décimaux ».
 * Une entrée par generator_key (cf. gen_613.js).
 */

// ── Poser le calcul entier, puis placer la virgule : animation (id cp613play1) ──
// Exemple hors pool du générateur : 1,3 × 1,2 → on pose 13 × 12 = 156,
// on compte 1 + 1 = 2 décimales, la virgule se place : 1,56.
const SVG_CALCMULT_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 240" role="img"
     aria-label="Pour calculer 1,3 fois 1,2 : on pose la multiplication sans les virgules, 13 fois 12. 13 fois 2 égale 26, 13 fois 10 égale 130, la somme fait 156. Chaque facteur a une décimale, soit deux décimales en tout : la virgule se place de deux rangs dans 156, le résultat est 1,56">
  <g id="cp613play1" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- consigne -->
  <text x="20" y="50" font-size="13" font-weight="600" fill="#64748b" font-family="system-ui,sans-serif" opacity="0">Pour 1,3 × 1,2 : pose d'abord 13 × 12<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp613play1.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp613play1.click+0.3s" fill="freeze"/></text>
  <!-- multiplication posée -->
  <g font-size="16" font-weight="700" fill="#0f172a" font-family="ui-monospace,monospace" text-anchor="end">
    <g opacity="0">
      <text x="104" y="82">13</text>
      <text x="104" y="102">12</text>
      <text x="58" y="102" text-anchor="start" fill="#64748b">×</text>
      <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp613play1.click" fill="freeze"/>
      <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp613play1.click+1.4s" fill="freeze"/>
    </g>
    <line x1="56" y1="110" x2="108" y2="110" stroke="#0f172a" stroke-width="1.4" opacity="0"><animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp613play1.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp613play1.click+1.4s" fill="freeze"/></line>
    <g opacity="0">
      <text x="104" y="130">26</text>
      <text x="114" y="130" text-anchor="start" font-size="11" font-weight="600" fill="#64748b" font-family="system-ui,sans-serif">(13 × 2)</text>
      <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp613play1.click" fill="freeze"/>
      <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp613play1.click+2.6s" fill="freeze"/>
    </g>
    <g opacity="0">
      <text x="58" y="150" text-anchor="start" fill="#64748b">+</text>
      <text x="104" y="150">130</text>
      <text x="114" y="150" text-anchor="start" font-size="11" font-weight="600" fill="#64748b" font-family="system-ui,sans-serif">(13 × 10)</text>
      <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp613play1.click" fill="freeze"/>
      <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp613play1.click+3.8s" fill="freeze"/>
    </g>
    <line x1="56" y1="158" x2="108" y2="158" stroke="#0f172a" stroke-width="1.4" opacity="0"><animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp613play1.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp613play1.click+5s" fill="freeze"/></line>
    <text x="104" y="178" fill="#1D9E75" opacity="0">156<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp613play1.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp613play1.click+5s" fill="freeze"/></text>
  </g>
  <!-- comptage des décimales -->
  <g opacity="0">
    <text x="250" y="100" font-size="18" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">1,3 × 1,2</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp613play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp613play1.click+6.2s" fill="freeze"/>
  </g>
  <g opacity="0">
    <path d="M212,108 Q222,122 232,108" fill="none" stroke="#1D9E75" stroke-width="1.8"/>
    <path d="M266,108 Q276,122 286,108" fill="none" stroke="#1D9E75" stroke-width="1.8"/>
    <text x="250" y="140" font-size="12" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">1 + 1 = 2 décimales</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp613play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp613play1.click+7.4s" fill="freeze"/>
  </g>
  <!-- placement de la virgule -->
  <g opacity="0">
    <text x="252" y="172" font-size="15" font-weight="700" fill="#1D9E75" text-anchor="end" font-family="system-ui,sans-serif">résultat : 1</text>
    <text x="261" y="172" font-size="15" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">,</text>
    <text x="272" y="172" font-size="15" font-weight="700" fill="#1D9E75" text-anchor="start" font-family="system-ui,sans-serif">56</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp613play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp613play1.click+8.6s" fill="freeze"/>
  </g>
  <g opacity="0">
    <ellipse cx="282" cy="167" rx="15" ry="12" fill="none" stroke="#B45309" stroke-width="1.8"/>
    <text x="282" y="192" font-size="11" font-weight="700" fill="#B45309" text-anchor="middle" font-family="system-ui,sans-serif">les 2 décimales</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp613play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp613play1.click+9.4s" fill="freeze"/>
  </g>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="198" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="206" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Pose le calcul avec les entiers.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp613play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp613play1.click+9.8s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="220" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="228" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Autant de décimales que dans les deux facteurs.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp613play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp613play1.click+10.4s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_CALCMULT_613 = {
    pages: [
        {
            titre: 'La méthode',
            svg: SVG_CALCMULT_ANIM,
        },
    ],
};

const CP_613 = {
    calcmult_qcm_unique: CP_CALCMULT_613,
    // Entrée partagée : la saisie demande exactement le geste de l'animation
    // (poser le calcul entier, puis placer la virgule).
    calcmult_texte: CP_CALCMULT_613,
    calcmult_relier: CP_CALCMULT_613,
    calcmult_tableau_vf: CP_CALCMULT_613,
    calcmult_texte_trou_drag: CP_CALCMULT_613,
};

export default CP_613;
